import * as React from 'react'

import { cn } from '@/lib/utils'
import { useMessageActionButtonsOverflow } from '@/hooks/use-message-action-buttons-overflow'

interface MessageActionButtonsContainerProps {
  className: string
  isVisible: boolean
  boundaryRef?: React.RefObject<HTMLElement | null>
  children: React.ReactNode
}

export const MessageActionButtonsContainer: React.FC<MessageActionButtonsContainerProps> = ({
  className,
  isVisible,
  boundaryRef,
  children,
}) => {
  const { actionButtonsRef, overflowStyle } = useMessageActionButtonsOverflow(isVisible, boundaryRef)

  return (
    <div ref={actionButtonsRef} className={cn('relative z-10', className)} style={overflowStyle}>
      {children}
    </div>
  )
}
